import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=637be9d5&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=637be9d5&scoped=true&lang=css&"
import style1 from "./Table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637be9d5",
  null
  
)

export default component.exports